import Link from "next/link";

interface CMSButtonProps {
  type:
    | "enroll"
    | "tour"
    | "contact"
    | "feeStructure"
    | "cambridgeSubjects"
    | "gallery";
  className?: string;
  children: React.ReactNode;
}

export default function CMSButton({
  type,
  className,
  children,
}: CMSButtonProps) {
  // Contact buttons always go to /contact-us
  if (type === "contact") {
    return (
      <Link href="/contact-us" className={className}>
        {children}
      </Link>
    );
  }

  // For server components, use fallback URLs
  let href = "/contact-us"; // Default fallback

  switch (type) {
    case "enroll":
      href = "/contact-us";
      break;
    case "tour":
      href = "/contact-us";
      break;
    case "gallery":
      href = "/gallery";
      break;
    case "feeStructure":
    case "cambridgeSubjects":
      href = "#"; // Will be overridden by CMS URL
      break;
  }

  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}

// Client version for use in client components
export function CMSButtonClient({
  type,
  className,
  children,
  siteConfig,
}: CMSButtonProps & {
  siteConfig?: {
    fields?: {
      enrollNowUrl?: string;
      bookTourUrl?: string;
      feeStructureUrl?: string;
      cambridgeSubjectsUrl?: string;
    };
  };
}) {
  // Contact buttons always go to /contact-us
  if (type === "contact") {
    return (
      <Link href="/contact-us" className={className}>
        {children}
      </Link>
    );
  }

  let href = "/contact-us"; // Fallback

  if (siteConfig?.fields) {
    switch (type) {
      case "enroll":
        href = siteConfig.fields.enrollNowUrl || "/contact-us";
        break;
      case "tour":
        href = siteConfig.fields.bookTourUrl || "/contact-us";
        break;
      case "gallery":
        href = "/gallery";
        break;
      case "feeStructure":
        href = siteConfig.fields.feeStructureUrl || "#";
        break;
      case "cambridgeSubjects":
        href = siteConfig.fields.cambridgeSubjectsUrl || "#";
        break;
    }
  } else {
    // Fallback URLs when no CMS config available
    switch (type) {
      case "enroll":
        href = "/contact-us";
        break;
      case "tour":
        href = "/contact-us";
        break;
      case "gallery":
        href = "/gallery";
        break;
      case "feeStructure":
      case "cambridgeSubjects":
        href = "#";
        break;
    }
  }

  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}
